import { useState } from "react";
import { useImageGeneration } from "./useImageGeneration";
import { useDrillManagement } from "./useDrillManagement";
import { useAuthNavigation } from "./useAuthNavigation";

export const useDashboard = () => {
  const [showImageDialog, setShowImageDialog] = useState(false);
  
  const {
    generatedImage,
    setGeneratedImage,
    isGeneratingImage,
    handleGenerateImage,
  } = useImageGeneration();

  const {
    loading,
    drillText,
    setDrillText,
    savedDrills,
    handleCreateDrill: createDrill,
    handleDeleteDrill,
  } = useDrillManagement();

  const { handleLogout, navigate } = useAuthNavigation();

  const handleCreateDrill = async () => {
    await createDrill(generatedImage);
    setGeneratedImage(null);
  };

  return {
    loading,
    drillText,
    setDrillText,
    generatedImage,
    setGeneratedImage,
    isGeneratingImage,
    savedDrills,
    showImageDialog,
    setShowImageDialog,
    handleLogout,
    handleCreateDrill,
    handleGenerateImage,
    handleDeleteDrill,
    navigate,
  };
};